// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sales_wrapper__QvLyF {
  height: calc(100vh - 150px); /* подстрой при необходимости */
  display: flex;
  flex-direction: column;
  position: relative; /* чтобы topActions с absolute позиционировались внутри */
}

/* top actions справа */
.Sales_topActions__W2jM2 {
  position: absolute;
  right: 0;
  top: -56px;
  display: flex;
  gap: 10px;
  align-items: center;
}

.Sales_searchBtn__3ZsYQ {
  height: 34px;
  padding: 0 14px;
  border: none;
  border-radius: 6px;
  background: #000;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.Sales_addBtn__GrZss {
  height: 34px;
  width: 44px;
  border: none;
  border-radius: 8px;
  background: rgba(122, 195, 31, 1);
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.Sales_moreBtn__UJjEE {
  height: 34px;
  width: 38px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.Sales_cards__\\+Ws8Z,
.Sales_filters__u4HwV {
  flex-shrink: 0;
}

/* cards */
.Sales_cards__\\+Ws8Z {
  display: grid;
  grid-template-columns: repeat(5, minmax(180px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.Sales_card__C1po0 {
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  padding: 16px 18px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
}

.Sales_cardTitle__0SX9b {
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
}

.Sales_cardValueBlue__kAxHw {
  font-size: 26px;
  font-weight: 600;
  color: rgba(37, 99, 235, 1);
}

.Sales_cardValueGreen__RKggl {
  font-size: 26px;
  font-weight: 600;
  color: rgba(34, 197, 94, 1);
}

.Sales_cardValueOrange__exHyC {
  font-size: 26px;
  font-weight: 600;
  color: rgba(245, 158, 11, 1);
}

.Sales_cardValueBlack__4ZrGC {
  font-size: 26px;
  font-weight: 600;
  color: #111;
}

/* filters */
.Sales_filters__u4HwV {
  display: grid;
  grid-template-columns: repeat(6, minmax(160px, 1fr));
  gap: 12px;
  margin: 10px 0 14px;
}

.Sales_input__9VEhL {
  height: 38px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 0 12px;
  background: #fff;
  outline: none;
  font-size: 14px;
}

.Sales_input__9VEhL:focus {
  border-color: rgba(29, 135, 82, 1);
}

.Sales_dateWrap__XmHUA {
  position: relative;
}

.Sales_inputDate__USfkB {
  height: 38px;
  width: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 0 42px 0 12px;
  background: #fff;
  outline: none;
  font-size: 14px;
}

.Sales_dateIcon__BIQa4 {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
  pointer-events: none;
}

/* table */
.Sales_tableWrap__iD5JD {
  flex: 1 1;
  min-height: 0; /* важно для корректной работы overflow в flex-контейнере */
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  overflow: hidden;
}

.Sales_tableBody__9HvZp {
  flex: 1 1;
  min-height: 0; /* важно */
  overflow-y: auto; /* скролл только у таблицы */
}

/* красивый скролл (Chrome/Edge) */
.Sales_tableBody__9HvZp::-webkit-scrollbar {
  width: 8px;
}

.Sales_tableBody__9HvZp::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 4px;
}

.Sales_tableBody__9HvZp::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

.Sales_table__oNsqH {
  width: 100%;
  border-collapse: collapse;
}

.Sales_th__nqLll,
.Sales_td__kB1st {
  padding: 12px 10px;
  font-size: 14px;
  border-bottom: 1px solid #ededed;
  text-align: left;
}

.Sales_th__nqLll {
  color: #6b7280;
  font-weight: 500;
  background: #fff;
}

/* фиксируем шапку таблицы */
.Sales_table__oNsqH thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
}

.Sales_thCheck__P2R37,
.Sales_tdCheck__OCaGT {
  width: 40px;
  text-align: center;
}

.Sales_thRight__IqYer {
  width: 56px;
  text-align: right;
  padding-right: 12px;
}

.Sales_tdActions__GpfuE {
  width: 56px;
  text-align: right;
  padding-right: 12px;
}

.Sales_rowSelected__8blMv {
  background: #f3f4f6;
}

.Sales_tdLink__yvGwr {
  padding: 12px 10px;
  border-bottom: 1px solid #ededed;
}

.Sales_linkBtn__wwrJD {
  background: none;
  border: none;
  color: #2563eb;
  cursor: pointer;
  padding: 0;
  font-size: 14px;
}

.Sales_iconBtn__RPRIb {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
}

.Sales_iconBtn__RPRIb:hover {
  background: #f0f0f0;
}

/* badge */
.Sales_badge__mDTXy {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.Sales_badgeGray__L-z40 {
  background: #6b7280;
  color: #fff;
}

.Sales_badgeRed__RFCBV {
  background: #dc2626;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Realization/Sales.module.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B,EAAE,+BAA+B;EAC5D,aAAa;EACb,sBAAsB;EACtB,kBAAkB,EAAE,yDAAyD;AAC/E;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,oBAAoB;AACtB;;AAEA,UAAU;AACV;EACE,SAAO;EACP,aAAa,EAAE,2DAA2D;EAC1E,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa,EAAE,UAAU;EACzB,gBAAgB,EAAE,4BAA4B;AAChD;;AAEA,kCAAkC;AAClC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb","sourcesContent":[".wrapper {\n  height: calc(100vh - 150px); /* подстрой при необходимости */\n  display: flex;\n  flex-direction: column;\n  position: relative; /* чтобы topActions с absolute позиционировались внутри */\n}\n\n/* top actions справа */\n.topActions {\n  position: absolute;\n  right: 0;\n  top: -56px;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.searchBtn {\n  height: 34px;\n  padding: 0 14px;\n  border: none;\n  border-radius: 6px;\n  background: #000;\n  color: #fff;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.addBtn {\n  height: 34px;\n  width: 44px;\n  border: none;\n  border-radius: 8px;\n  background: rgba(122, 195, 31, 1);\n  color: #fff;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.moreBtn {\n  height: 34px;\n  width: 38px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cards,\n.filters {\n  flex-shrink: 0;\n}\n\n/* cards */\n.cards {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(180px, 1fr));\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.card {\n  background: #fff;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  padding: 16px 18px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);\n}\n\n.cardTitle {\n  font-size: 14px;\n  color: #333;\n  margin-bottom: 8px;\n}\n\n.cardValueBlue {\n  font-size: 26px;\n  font-weight: 600;\n  color: rgba(37, 99, 235, 1);\n}\n\n.cardValueGreen {\n  font-size: 26px;\n  font-weight: 600;\n  color: rgba(34, 197, 94, 1);\n}\n\n.cardValueOrange {\n  font-size: 26px;\n  font-weight: 600;\n  color: rgba(245, 158, 11, 1);\n}\n\n.cardValueBlack {\n  font-size: 26px;\n  font-weight: 600;\n  color: #111;\n}\n\n/* filters */\n.filters {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(160px, 1fr));\n  gap: 12px;\n  margin: 10px 0 14px;\n}\n\n.input {\n  height: 38px;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  padding: 0 12px;\n  background: #fff;\n  outline: none;\n  font-size: 14px;\n}\n\n.input:focus {\n  border-color: rgba(29, 135, 82, 1);\n}\n\n.dateWrap {\n  position: relative;\n}\n\n.inputDate {\n  height: 38px;\n  width: 100%;\n  border: 1px solid #d9d9d9;\n  border-radius: 8px;\n  padding: 0 42px 0 12px;\n  background: #fff;\n  outline: none;\n  font-size: 14px;\n}\n\n.dateIcon {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #666;\n  pointer-events: none;\n}\n\n/* table */\n.tableWrap {\n  flex: 1;\n  min-height: 0; /* важно для корректной работы overflow в flex-контейнере */\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.tableBody {\n  flex: 1;\n  min-height: 0; /* важно */\n  overflow-y: auto; /* скролл только у таблицы */\n}\n\n/* красивый скролл (Chrome/Edge) */\n.tableBody::-webkit-scrollbar {\n  width: 8px;\n}\n\n.tableBody::-webkit-scrollbar-thumb {\n  background: #d1d5db;\n  border-radius: 4px;\n}\n\n.tableBody::-webkit-scrollbar-thumb:hover {\n  background: #9ca3af;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.th,\n.td {\n  padding: 12px 10px;\n  font-size: 14px;\n  border-bottom: 1px solid #ededed;\n  text-align: left;\n}\n\n.th {\n  color: #6b7280;\n  font-weight: 500;\n  background: #fff;\n}\n\n/* фиксируем шапку таблицы */\n.table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #fff;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.thCheck,\n.tdCheck {\n  width: 40px;\n  text-align: center;\n}\n\n.thRight {\n  width: 56px;\n  text-align: right;\n  padding-right: 12px;\n}\n\n.tdActions {\n  width: 56px;\n  text-align: right;\n  padding-right: 12px;\n}\n\n.rowSelected {\n  background: #f3f4f6;\n}\n\n.tdLink {\n  padding: 12px 10px;\n  border-bottom: 1px solid #ededed;\n}\n\n.linkBtn {\n  background: none;\n  border: none;\n  color: #2563eb;\n  cursor: pointer;\n  padding: 0;\n  font-size: 14px;\n}\n\n.iconBtn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 6px;\n}\n\n.iconBtn:hover {\n  background: #f0f0f0;\n}\n\n/* badge */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.badgeGray {\n  background: #6b7280;\n  color: #fff;\n}\n\n.badgeRed {\n  background: #dc2626;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Sales_wrapper__QvLyF`,
	"topActions": `Sales_topActions__W2jM2`,
	"searchBtn": `Sales_searchBtn__3ZsYQ`,
	"addBtn": `Sales_addBtn__GrZss`,
	"moreBtn": `Sales_moreBtn__UJjEE`,
	"cards": `Sales_cards__+Ws8Z`,
	"filters": `Sales_filters__u4HwV`,
	"card": `Sales_card__C1po0`,
	"cardTitle": `Sales_cardTitle__0SX9b`,
	"cardValueBlue": `Sales_cardValueBlue__kAxHw`,
	"cardValueGreen": `Sales_cardValueGreen__RKggl`,
	"cardValueOrange": `Sales_cardValueOrange__exHyC`,
	"cardValueBlack": `Sales_cardValueBlack__4ZrGC`,
	"input": `Sales_input__9VEhL`,
	"dateWrap": `Sales_dateWrap__XmHUA`,
	"inputDate": `Sales_inputDate__USfkB`,
	"dateIcon": `Sales_dateIcon__BIQa4`,
	"tableWrap": `Sales_tableWrap__iD5JD`,
	"tableBody": `Sales_tableBody__9HvZp`,
	"table": `Sales_table__oNsqH`,
	"th": `Sales_th__nqLll`,
	"td": `Sales_td__kB1st`,
	"thCheck": `Sales_thCheck__P2R37`,
	"tdCheck": `Sales_tdCheck__OCaGT`,
	"thRight": `Sales_thRight__IqYer`,
	"tdActions": `Sales_tdActions__GpfuE`,
	"rowSelected": `Sales_rowSelected__8blMv`,
	"tdLink": `Sales_tdLink__yvGwr`,
	"linkBtn": `Sales_linkBtn__wwrJD`,
	"iconBtn": `Sales_iconBtn__RPRIb`,
	"badge": `Sales_badge__mDTXy`,
	"badgeGray": `Sales_badgeGray__L-z40`,
	"badgeRed": `Sales_badgeRed__RFCBV`
};
export default ___CSS_LOADER_EXPORT___;
